export const generateCacheInvalidator = () => Date.now();
export const NO_CACHE_PARAM_KEY = 'nocache';
export const NO_CACHE_PARAM = `${NO_CACHE_PARAM_KEY}=${generateCacheInvalidator()}`;
export const NO_CACHE_HEADER = 'no-cache';
